const v = {
  name: "FrameRate",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h40v32h-2v4h-2v4H4v-4H2v-4H0V0z M36,32H4v2h32V32z M34,30V2H6v28H34z M36,2v3h2V2H36z M38,7h-2v3h2V7z
			 M38,12h-2v3h2V12z M38,17h-2v3h2V17z M38,22h-2v3h2V22z M38,27h-2v3h2V27z M2,2v3h2V2H2z M2,7v3h2V7H2z M2,12v3h2v-3H2z M2,17v3
			h2v-3H2z M2,22v3h2v-3H2z M2,27v3h2v-3H2z M6,36v2h28v-2H6z"/>
	</g>
</g>
</svg>
  `
};
export {
  v as FrameRate
};
